var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobDetailAgencyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38.718,
    height: 38.719,
    viewBox: "0 0 38.718 38.719",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3165",
    d: "M0-682.665H38.718v38.719H0Z",
    transform: "translate(0 682.665)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g3159",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3161",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3163",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3169",
    transform: "translate(5.994 5.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3171",
    d: "M-394.041,0H-414.7a3.046,3.046,0,0,0-3.037,3.038V31.59H-391V3.038A3.046,3.046,0,0,0-394.041,0Z",
    transform: "translate(417.734)",
    fill: "none",
    stroke: "#d9a239",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3173",
    transform: "translate(10.854 1.134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3175",
    d: "M0-80.829v-1.822a3.046,3.046,0,0,1,3.037-3.037H13.972a3.046,3.046,0,0,1,3.037,3.037v1.822",
    transform: "translate(0 85.689)",
    fill: "none",
    stroke: "#d9a239",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3177",
    transform: "translate(14.499 30.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3179",
    d: "M0-121.243V-125.5a3.046,3.046,0,0,1,3.038-3.038H6.682A3.046,3.046,0,0,1,9.72-125.5v4.252",
    transform: "translate(0 128.533)",
    fill: "none",
    stroke: "#d9a239",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3181",
    transform: "translate(19.359 30.294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3183",
    d: "M0-121.243v-7.29",
    transform: "translate(0 128.533)",
    fill: "none",
    stroke: "#d9a239",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3185",
    transform: "translate(12.069 10.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3187",
    d: "M0,0H0",
    fill: "none",
    stroke: "#d9a239",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3189",
    transform: "translate(16.929 10.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3191",
    d: "M0,0H0",
    fill: "none",
    stroke: "#d9a239",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3193",
    transform: "translate(12.069 15.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3195",
    d: "M0,0H0",
    fill: "none",
    stroke: "#d9a239",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3197",
    transform: "translate(16.929 15.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3199",
    d: "M0,0H0",
    fill: "none",
    stroke: "#d9a239",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3201",
    transform: "translate(12.069 20.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3203",
    d: "M0,0H0",
    fill: "none",
    stroke: "#d9a239",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3205",
    transform: "translate(16.929 20.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3207",
    d: "M0,0H0",
    fill: "none",
    stroke: "#d9a239",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3209",
    transform: "translate(12.069 25.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3211",
    d: "M0,0H0",
    fill: "none",
    stroke: "#d9a239",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3213",
    transform: "translate(16.929 25.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3215",
    d: "M0,0H0",
    fill: "none",
    stroke: "#d9a239",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3217",
    transform: "translate(21.789 10.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3219",
    d: "M0,0H0",
    fill: "none",
    stroke: "#d9a239",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3221",
    transform: "translate(26.649 10.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3223",
    d: "M0,0H0",
    fill: "none",
    stroke: "#d9a239",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3225",
    transform: "translate(21.789 15.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3227",
    d: "M0,0H0",
    fill: "none",
    stroke: "#d9a239",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3229",
    transform: "translate(26.649 15.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3231",
    d: "M0,0H0",
    fill: "none",
    stroke: "#d9a239",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3233",
    transform: "translate(21.789 20.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3235",
    d: "M0,0H0",
    fill: "none",
    stroke: "#d9a239",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3237",
    transform: "translate(26.649 20.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3239",
    d: "M0,0H0",
    fill: "none",
    stroke: "#d9a239",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3241",
    transform: "translate(21.789 25.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3243",
    d: "M0,0H0",
    fill: "none",
    stroke: "#d9a239",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3245",
    transform: "translate(26.649 25.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3247",
    d: "M0,0H0",
    fill: "none",
    stroke: "#d9a239",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobDetailAgencyIcon);
export default __webpack_public_path__ + "static/media/jobDetail_Agency_icon.ad3fbc2c24c5e22d08158343238be1b2.svg";
export { ForwardRef as ReactComponent };